<template lang="pug">
  form.formulario#contato_form(v-on:submit.prevent="enviaEmail")
    mensagem.-warn(v-if="statusEnvio == 1")
      p {{ mensagemRetorno }}
    mensagem.-info(v-if="statusEnvio == 2")
      p {{ mensagemRetorno }}
    .form-group
      label(for="nome") Nome
      input.form-control(type="text" id="nome"  v-model="dadosFormulario.nome")
      span(v-if='mensagensErro.erroNome.length > 0'): small {{ mensagensErro.erroNome }}
    .form-group
      label(for="email") Email
      input.form-control(type="text" id="email" v-model="dadosFormulario.email")
      span(v-if='mensagensErro.erroEmail.length > 0'): small {{ mensagensErro.erroEmail }}
    .form-group
      label(for="assunto") Assunto
      input.form-control(type="text" id="assunto" v-model="dadosFormulario.assunto")
      span(v-if='mensagensErro.erroAssunto.length > 0'): small {{ mensagensErro.erroAssunto }}
    .form-group
      label Mensagem
      textarea.form-control(rows="7" v-model="dadosFormulario.mensagem")
      span(v-if='mensagensErro.erroMensagem.length > 0'): small {{ mensagensErro.erroMensagem }}
    .form-group
      label Verificação
      .input-group(style="font-family: Arial;")
        .input-group-addon {{ expressao }}
        input.form-control(type="number" id="verificacao" placeholder="???", v-model='resultadoExpressao')
      span(v-if='mensagensErro.erroExpressao.length > 0'): small {{ mensagensErro.erroExpressao }}
    .buttons
      button.btn.btn-outline(type="reset") Limpar
      button.btn.btn-form(type="submit") Enviar
</template>

<style lang="scss">
  .formulario {
    color: $color-blue-dark;

    .mensagem {
      margin: 30px 0;

      &.-info {
        color: #00B233;
      }
      &.-warn {
        color: red;
      }

      p {
        margin: 0;
      }
    }

    > .form-group {
      position: relative;
      margin-bottom: 20px;
      > input, textarea { background-color: #F2F2F2; border-radius: 7px }
      > input { min-height: 30px; }
      > label { margin-bottom: 10px; }
      > span { color: red; }
    }

    .btn { border-radius: 7px; font-size: 16px; }
    .btn-form { color: white }

    .btn-blue-dark {
      background-color: $color-blue-dark;
      color: $color-neutral;
      &:hover {
        background-color: darken($color-blue-dark,10);
      }
    }

    .buttons {
      width: 100%;
      margin-top: 20px;
      text-align: center;

      > .btn {
        margin: 0 11px;
        min-height: 40px;
        min-width: 100px;
      }

      > .btn-form {
        background-color: $color-blue-dark;
        color: white;
        &:hover {
          background-color: darken($color-blue-dark,10);
        }
      }
    }

    .btn-outline {
      background-color: $color-neutral;
      color: inherit;
      border: 1px solid $color-blue-dark;
      &:hover {
        background-color: darken($color-blue-dark,10);
        border: 1px solid darken($color-blue-dark,10);
        color: $color-neutral;
      }
    }

  }
</style>

<script>
  import Mensagem from 'COMPONENTS/Mensagem'
  import EmailService from '../../js/api/EmailService'
  import ExpressaoMatematica from '../../js/expressaoMatematica'
  export default {
    name: 'formulario',
    props: ['destino'],
    components: {
      Mensagem
    },
    data: function () {
      return {
        statusEnvio: 0, // 0: aguardando - 1: erro - 2: sucesso
        dadosFormulario: {
          nome: '',
          email: '',
          assunto: '',
          mensagem: '',
          unidade: this.destino
        },
        mensagensErro: {
          erroNome: '',
          erroEmail: '',
          erroAssunto: '',
          erroMensagem: '',
          erroExpressao: ''
        },
        mensagemRetorno: '',
        expressao: ExpressaoMatematica.gerarExpressao(),
        resultadoExpressao: ''
      }
    },
    methods: {
      resetForm () {
        this.dadosFormulario.nome = ''
        this.dadosFormulario.email = ''
        this.dadosFormulario.assunto = ''
        this.dadosFormulario.mensagem = ''
      },
      atualizarMensagem (status, message) {
        this.statusEnvio = status
        this.mensagemRetorno = message
      },
      validaFormulario () {
        let status = true
        let erEmail = /^[^0-9][a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[@][a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,4}$/
        if (this.dadosFormulario.nome === '') {
          this.mensagensErro.erroNome = 'O campo Nome é obrigatório'
          status = false
        } else {
          this.mensagensErro.erroNome = ''
        }
        if (this.dadosFormulario.email === '') {
          this.mensagensErro.erroEmail = 'O campo E-mail é obrigatório'
          status = false
        } else if (!erEmail.exec(this.dadosFormulario.email)) {
          this.mensagensErro.erroEmail = 'O campo E-mail precisa ser válido'
          status = false
        } else {
          this.mensagensErro.erroEmail = ''
        }
        if (this.dadosFormulario.assunto === '') {
          this.mensagensErro.erroAssunto = 'O campo Assunto é obrigatório'
          status = false
        } else {
          this.mensagensErro.erroAssunto = ''
        }
        if (this.dadosFormulario.mensagem === '') {
          this.mensagensErro.erroMensagem = 'O campo Mensagem é obrigatório'
          status = false
        } else {
          this.mensagensErro.erroMensagem = ''
        }
        if (!ExpressaoMatematica.validarExpressao(this.expressao, this.resultadoExpressao)) {
          this.mensagensErro.erroExpressao = 'O resultado da expressão não está correto'
          status = false
        } else {
          this.mensagensErro.erroExpressao = ''
        }
        return status
      },
      enviaEmail () {
        if (this.validaFormulario()) {
          EmailService.enviaEmail(this.dadosFormulario)
          .then(response => {
            if (response.status === 'success') {
              this.atualizarMensagem(2, response.message)
              this.resetForm()
            } else {
              this.atualizarMensagem(1, response.message)
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Formulario.vue?364e4eee